import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { CoreComponent } from '../core/core.component.js';

@Component({
    selector: 'lib-focused-card',
    templateUrl: './focused-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FocusedCardComponent extends CoreComponent {
	public readonly title = input.required<string>();
	public readonly subtitle = input<string>();

	@HostBinding('style') override style = 'display: block';

	constructor() {
		super();
	}
}
